import type { AnomalyBlock, DrillAction } from '../types.js';
import { Digits } from './Digits.js';
import { V2Badge } from '@sakhtar/design-system/react';

export interface AnomalyCardProps {
  readonly anomaly: AnomalyBlock;
  readonly onDrill: (action: DrillAction) => void;
  readonly disabled: boolean;
}

/** Component 7 — anomaly («نکتهٔ قابل توجه») with one follow-up action. */
export function AnomalyCard({ anomaly, onDrill, disabled }: AnomalyCardProps) {
  return (
    <div className="ai-block ai-anomaly">
      <V2Badge tone="warn">{anomaly.badge}</V2Badge>
      <div className="ai-anomaly__text">
        {anomaly.text.map((part, index) =>
          typeof part === 'string' ? (
            <Digits key={index}>{part}</Digits>
          ) : (
            <strong key={index} className="sk-num">
              {part.strong}
            </strong>
          ),
        )}
      </div>
      <button
        type="button"
        className="sk-btn sk-btn--secondary sk-btn--sm ai-pill"
        disabled={disabled}
        onClick={() => onDrill(anomaly.action.action)}
      >
        {anomaly.action.label}
      </button>
    </div>
  );
}
